export function normalizeTxArray(rawTxs) {
    return rawTxs.map(tx => ({
        ...tx,
        time: new Date((Number(tx.timeSec) || 0) * 1000),
        valueNorm: normalizeValue(tx.valueRaw, tx.network),
    }));
}

function normalizeValue(valueRaw, network) {
    const asNum = Number(valueRaw || 0);
    if (!isFinite(asNum) || asNum <= 0) {
        return 0;
    }

    if (network === 'Ethereum' || network === 'Polygon' || network === 'BSC') {
        return asNum / 1e18;
    }

    return asNum / 1e9;
}
